import { timelineBlocks } from '@/mocks/guaHome';

const statusStyle: Record<string, string> = {
  已归档: 'bg-emerald-50 text-emerald-600 border-emerald-200',
  补录中: 'bg-amber-50 text-amber-700 border-amber-200',
  待复核: 'bg-stone-100 text-stone-500 border-stone-200',
};

export default function TimelineDir() {
  return (
    <section id="timeline" className="scroll-mt-20 bg-[#f8f4ec]">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-8 items-center rounded-full bg-red-600/10 px-3 text-xs font-bold tracking-widest text-red-600">05 · 目录</span>
              <span className="text-xs font-medium tracking-widest text-stone-400 uppercase">Timeline</span>
            </div>
            <h2 className="font-serif-sc mt-3 text-2xl font-bold text-stone-900 md:text-3xl">目录老帖 · 按时间线复盘</h2>
            <p className="mt-2 max-w-2xl text-sm text-stone-500">老帖按年份归档成目录，标出补录与复核进度，照着时间线把遗漏一条条过掉。</p>
          </div>
          <div className="flex items-center gap-4 self-start text-xs text-stone-500 md:self-auto">
            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full bg-emerald-500" />已归档</span>
            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full bg-amber-400" />补录中</span>
            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full bg-stone-400" />待复核</span>
          </div>
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          {timelineBlocks.map((block) => (
            <div key={block.year} className="flex flex-col rounded-2xl border border-stone-200/80 bg-white p-5">
              <div className="flex items-center justify-between border-b border-dashed border-stone-200 pb-4">
                <div className="flex items-baseline gap-2">
                  <span className="font-serif-sc text-3xl font-black text-red-600">{block.year}</span>
                  <span className="text-xs font-medium text-stone-400">年段</span>
                </div>
                <span className="rounded-full bg-stone-100 px-2.5 py-1 text-[11px] font-medium text-stone-500">{block.label}</span>
              </div>

              <ul className="mt-2 flex-1 divide-y divide-stone-100">
                {block.items.map((it) => (
                  <li key={it.no}>
                    <a href="#faq" className="group flex items-center justify-between gap-2 py-3.5">
                      <div className="flex min-w-0 items-center gap-3">
                        <span className="shrink-0 font-mono text-[11px] font-bold text-stone-300 group-hover:text-red-400">{it.no}</span>
                        <div className="min-w-0">
                          <div className="truncate text-sm font-semibold text-stone-800 group-hover:text-red-600">{it.title}</div>
                          <div className="mt-1 text-[11px] text-stone-400">{it.zone}</div>
                        </div>
                      </div>
                      <span className={`shrink-0 whitespace-nowrap rounded-md border px-2 py-0.5 text-[10px] font-medium ${statusStyle[it.status]}`}>
                        {it.status}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 rounded-2xl border border-dashed border-stone-300 bg-white/60 px-5 py-4 text-center md:flex-row md:text-left">
          <div className="text-sm text-stone-500">
            目录老帖例行复核进行中，本周已复核 <b className="text-stone-800">320 篇</b> 老帖，修正截图与时间线误差。
          </div>
          <a
            href="#faq"
            className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-stone-900 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-red-600"
          >
            查看收录进度
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}